// import React, { useState } from "react";
// import { Modal, Box, Table, TableHead, TableRow, TableCell, TableBody, Button } from "@mui/material";
// import CloseIcon from "@mui/icons-material/Close";
// import EmailTemplateEditor from "./EmailTemplateEditor";
// import { Navigate } from "react-router-dom";

// export default function CountPopup({ open, onClose, data }) {
//   const [edit, setEdit] = useState(false);

//   return (
//     <>
//     {edit && <Navigate to="/email_builder" />}
//     <Modal open={open} onClose={onClose}>
//       <Box
//         sx={{
//           width: 400,
//           background: "white",
//           padding: 3,
//           borderRadius: 2,
//           position: "absolute",
//           top: "50%",
//           left: "50%",
//           transform: "translate(-50%, -50%)",
//           boxShadow: 3,
//         }}
//       >
//         {/* Header */}
//         <div className="flex justify-between items-center mb-4">
//           <div className="text-xl font-semibold">Column Counts</div>
//           {/* <Button variant="text" onClick={onClose}>
//             <CloseIcon />
//           </Button> */}
//         </div>

//         {/* Table */}
//         <Table>
//           <TableHead>
//             <TableRow>
//               <TableCell className="font-semibold">Column Name</TableCell>
//               <TableCell className="font-semibold">Data Count</TableCell>
//             </TableRow>
//           </TableHead>

//           <TableBody>
//             {Object.entries(data).map(([key, value]) => (
//               <TableRow key={key}>
//                 <TableCell>{key}</TableCell>
//                 <TableCell>{value}</TableCell>
//               </TableRow>
//             ))}
//           </TableBody>
//         </Table>

//         {/* Close Button */}
//         <div className="flex justify-end mt-4">
//           <Button variant="contained" onClick={() => {onClose(); setEdit(true);}}>
//             Edit Template
//           </Button>
//         </div>
//       </Box>
//     </Modal>
//     </>
//   );
// }

import React, { useState } from "react";
import {
  Modal,
  Box,
  Table,
  TableHead,
  TableRow,
  TableCell,
  TableBody,
  Button,
} from "@mui/material";
import { Navigate, useNavigate } from "react-router-dom";
import { Cross, CrossIcon } from "lucide-react";
import { Close } from "@mui/icons-material";
import api from "../../services/api";

export default function CountPopup({ open, onClose, data, payloadFor, query }) {
  const [edit, setEdit] = useState(false);
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleEditTemplate = async () => {
    setLoading(true);

    try {
      const response = await api.post(
        "/schedule_email/get_formatted_columns",
        payloadFor
      );

      // console.log("--------->column_names",response.data.column_names)
      // console.log("--------->payloadFor",payloadFor)
      // console.log("--------->query", query)

      if (response.data.success) {
        localStorage.setItem("emailTemplate", []);
        localStorage.setItem("sendToCcBccSubject", {});
        localStorage.setItem("attachments", []);
        localStorage.setItem("emailTemplateHistory", {});
        localStorage.setItem("column_data", JSON.stringify({
            column_names: response.data.column_names,
            filterPayload: payloadFor,
            query: query || "",
          }));
        navigate("/email_builder");
        window.location.reload();
      }
    } catch (err) {
      console.error("Error fetching formatted columns:", err);
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      {/* {edit && <Navigate to="/email_builder" />} */}
      <Modal open={open} onClose={onClose}>
        <Box
          className="
            w-[400px] bg-white p-4 rounded-lg shadow-lg 
            fixed top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2
            max-h-[80vh] flex flex-col
          "
        >
          <Close
            onClick={onClose}
            className="absolute top-3 right-3 cursor-pointer text-gray-600 hover:text-black"
          />
          {/* Header */}
          <div className="flex justify-between items-center mb-4">
            <div className="text-xl font-semibold">Column Counts</div>
          </div>
          {/* Scrollable Table Container */}
          <div className="overflow-y-auto max-h-[60vh]">
            <Table stickyHeader>
              <TableHead>
                <TableRow>
                  <TableCell className="font-semibold">Column Name</TableCell>
                  <TableCell className="font-semibold">Data Count</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {Object.entries(data).map(([key, value]) => (
                  <TableRow key={key}>
                    <TableCell>{key}</TableCell>
                    <TableCell>{value}</TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </div>
          {/* Footer */}
          <div className="flex justify-end mt-4">
            <Button
              variant="contained"
              onClick={handleEditTemplate}
              disabled={loading}
            >
              {loading ? "Loading..." : "Edit Template"}
            </Button>
          </div>
        </Box>
      </Modal>
    </>
  );
}
